// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__380ri","box":"WorkspacesBox_box__3S7KX","node":"WorkspacesBox_node__37Pkb"};